import { Model } from 'backbone';
import { View } from 'backbone.marionette';

import template from './index.jst';
import './index.styl';
import queryString from "query-string";
import { Secret, sendDataLayer } from "../../utils";
import { User } from "../../models";
import Storage from "../../utils/Storage";

const IS_PRE_SEASON = JSON.parse(process.env.IS_PRE_SEASON);

class HomeView extends View {
	get template() {
		return template;
	}

	initialize(){
		if (!this.model) {
			this.model = new Model({
				IS_PRE_SEASON: Secret.is_passed ? false : IS_PRE_SEASON
			});
		}
		const user = User.toJSON();

		this.model.set({
			news: [],
			is_no_user: !user.id
		});

		this.fetchData()
	}

	get className() {
		return "home-page";
	}

	ui() {
		return {
			play: '.js-play',
			signup: '.js-signup'
		};
	}

	events() {
		return {
			'click @ui.play': 'login',
			'click @ui.signup': 'signUp'

		};
	}

	signUp() {
		this.redirectToLoginViaNRLAccount('openid email profile offline_access signup');
	}

	login(el) {
		const user_requested_route_storage_key = "user_requested_route_before_auth";
		Storage.set(user_requested_route_storage_key, el.currentTarget.dataset.path);
		this.redirectToLoginViaNRLAccount('openid email profile offline_access');
	}

	/**
	 * Redirect to the NRL OpenID Connect authorise url with the required appended query parameters
	 *
	 * @memberof HomeController
	 */
	redirectToLoginViaNRLAccount(scope) {

		document.cookie = "session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

		const query_params = {
			client_id: process.env.NRL_AUTHORISATION_CLIENT_ID,
			response_type: 'code',
			grant_type: 'authorisation_code',
			scope,
			redirect_uri: location,
			// 'state' property doesn't get used by NRL Account, it is a way to pass information
			// through the NRL login redirects. It will come back as a param on the redirect_uri
			state: location // 'state' is being used for the redirect_uri to pass to API on login
		};

		const nrl_auth_url = [
			process.env.NRL_URL,
			'/account/authorize?',
			queryString.stringify(query_params)
		].join('');


		location.assign(nrl_auth_url);
	}

	async fetchData() {
		return this;
	}

	onRender() {
		sendDataLayer( {
			'event':     'virtual_page_view',
			'page_url':  '/',
			'page_name': 'home'
		} );
	}
}

export default HomeView;